<template>
  <div style="padding-top: 120px">
    <img
      class="banner"
      v-lazy="'https://www.xaryxx.com/images/images2/s39.png'"
    />

    <div class="content">
      <div class="box">
        <div class="title">公司地址</div>
      </div>

      <div class="box mapBox">
        <div class="infobox animate__animated animate__slideInLeft">
          <div>
            <div class="zh">西安荣业信息科技有限公司</div>
            <div class="en">Xi 'an Rongye lnformation Technology Co.,LTD</div>
            <div class="Certificates">
              {{ info.companySlogan }}
            </div>
          </div>
          <div class="infos">
            <div>公司地址：{{ info.companyAddress }}</div>
            <div>联系电话：{{ info.phone }}</div>
            <div>电子邮箱：{{ info.email }}</div>
          </div>
        </div>
        <div
          id="allmap"
          class="allmap animate__animated animate__slideInRight"
        ></div>
      </div>
    </div>
    <div style="background: #ffede3" class="content">
      <div class="box">
        <div class="title">
          <div>欢迎留言</div>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
        
          class="demo-ruleForm"
        >
        <div class="searchitems">
          <el-form-item  prop="name">
            <el-input
              placeholder="请输入您的姓名"
              v-model="ruleForm.name"
            ></el-input>
          </el-form-item>

          <el-form-item  prop="contactInformation">
            <el-input
              placeholder="请输入联系方式（手机、邮箱、QQ号码）"
              v-model="ruleForm.contactInformation"
            ></el-input>
          </el-form-item>
        </div>

          <el-form-item prop="remark">
            <el-input
              placeholder="请填写10个字以上的问题描述以便我们提供更好的帮助"
              type="textarea"
              v-model="ruleForm.remark"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              class="sub"
              type="warning"
              @click="submitForm('ruleForm')"
              >提交</el-button
            >
            <el-button class="clean" @click="resetForm('ruleForm')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import BannerTitle from "../common/banner-title";
import { submit } from "@/api/api";
import { companyInfo } from "@/api/api";
export default {
  data() {
    return {
      info: {},
      ruleForm: {
        name: "",
        contactInformation: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请填写您的姓名", trigger: "blur" }],
        contactInformation: [
          {
            required: true,
            message: "联系方式（手机、邮箱、QQ号码）",
            trigger: "blur",
          },
        ],
      },
    };
  },
  components: {
    BannerTitle,
  },
  mounted() {
    this.getcompanyInfo();
  },

  methods: {
    getcompanyInfo() {
      companyInfo().then((response) => {
        this.info = response.data;

        setTimeout(function () {
          var map = new BMapGL.Map("allmap");

          map.centerAndZoom(new BMapGL.Point(108.977345, 34.328004), 12);
          //创建地址解析器实例
          var myGeo = new BMapGL.Geocoder();
          //创建地址解析器实例
          var myGeo = new BMapGL.Geocoder();
          // 将地址解析结果显示在地图上，并调整地图视野
          myGeo.getPoint(
            response.data.companyAddress,
            function (point) {
              if (point) {
                map.centerAndZoom(point, 19);
                map.addOverlay(new BMapGL.Marker(point, { title: "西安荣业" }));
              } else {
                alert("您选择的地址没有解析到结果！");
              }
            },
            "西安市"
          );
        }, 2000);
      });
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          submit(this.ruleForm)
            .then((result) => {
              4;
              if (result.code == 200) {
                this.$message({
                  message: result.msg,
                  type: "success",
                });

                setTimeout(() => {
                  this.resetForm("ruleForm");
                }, 1500);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.mapBox {
  display: flex;
  margin-bottom: 100px !important;

  .allmap {
    height: 350px;
    width: 55%;
    // border: 6px solid rgba(0, 0, 0, 0.13);
    border-radius: 10px;
  }

  .infobox {
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: space-between;
    justify-content: space-between;
    height: 320px;
    margin-right: 50px;

    .Certificates {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #090909;
      line-height: 24px;
    }

    .zh {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #090909;
      line-height: 24px;
      // font-size: 25px;
      // font-family: PingFang SC-Regular, PingFang SC;
      // font-weight: 400;
      // line-height: 37px;
      // background: linear-gradient(360deg, #ff8400 0%, #e32200 100%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
    }

    .en {
      font-family: PingFang SC;
      font-weight: bold;
      font-size: 18px;
      color: #090909;
      line-height: 24px;
      margin: 15px 0;
      // font-size: 16px;
      // font-family: PingFang SC-Regular, PingFang SC;
      // font-weight: 400;
      // color: #898989;
      // line-height: 37px;
    }

    .infos > div {
      font-size: 16px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 23px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}

.banner {
  width: 100%;
  display: block;
  min-height: 500px;
}
.sub {
  width: 120px;
  height: 50px;
  background: #ff6019;
  border-radius: 25px;
  border: 2px solid transparent;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-right: 30px;
}
.clean {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #FF6019;
  width: 120px;
  height: 50px;
  background: none;
  border-radius: 25px;
  border: 2px solid #ff6019;
}

/deep/ .el-input__inner {
  height: 59px;
  background: #f4f4f4;
  border-radius: 4px 4px 4px 4px;
  border: none;
}

/deep/ .el-textarea__inner {
  height: 120px;
  background: #f4f4f4;
  border-radius: 4px 4px 4px 4px;
  border: none;
}

.title {
  font-family: PingFang SC;
  font-weight: bold;
  font-size: 30px;
  color: #090909;
  padding: 101px 0 74px;
}

.content {
  .imgs {
    margin: 50px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    > div {
      padding: 30px 0;
      width: 49%;
      box-shadow: 0 0 5px 2px #efefef;
      margin-bottom: 20px;
      margin-right: 10px;
      border-radius: 5px;

      &:nth-child(2n) {
        margin-right: 0;
      }

      > div {
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
        font-size: 17px;
        font-weight: bold;
      }

      img {
        display: block;
        margin: 0 auto;
        // width: 100%;
        border-radius: 5px;
      }

      ul {
        padding: 10px 5px;

        li {
          font-size: 16px;
          text-align: center;

          img {
            width: 40px;
            height: 40px;
            display: block;
            margin: 10px auto;
          }
        }
      }
    }
  }

  .box {
    width: 60%;
    margin: 0 auto;
    // background: #fff;

    .demo-ruleForm {
      padding-bottom: 80px;
      // padding: 60px 0 55px 0;
      width: 100%;
      margin: 0 auto;
      overflow: hidden;
      .searchitems{
        display: flex;
        .el-form-item{
          flex: 1;
          &:nth-child(1){
            margin-right: 23px;
          }
        }
      }
     /deep/ .el-input__inner,
     /deep/ .el-textarea__inner{
        background: #fff !important;
        box-shadow: 0px 0px 16px 0px rgba(202,112,63,0.19);
      }
      /deep/ .el-textarea__inner{
        margin-top: 15px;
        margin-bottom: 30px;
        height: 266px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comment/index.vue